import React from 'react'
import QuestionTpl from '../templates/QuestionTpl'
import { Select } from './Select'
import range from 'lodash/range'

const min = 1
const max = 5
const step = 1

function optionsFromRange({ min, max, step }) {    
    const options = range(min, max+1, step).map((r) => {
        return {
            label: `${r} years`,
            value: r
        }
    })
    return options
}

export default class LeaseTermQn extends React.Component {

    static id = 'lease_term';
    static defaultValue = '3';

    render() {
        const { id, value, onChange } = this.props;
        
        return (
            <QuestionTpl
                {...this.props}
                title="Lease term"
                description="Years"
                fineprint="Your lease term is the period you lease the vehicle"
                component={Select}
                componentProps={{
                    key: "lease_term",
                    value,
                    options: optionsFromRange({ min, max, step }),
                    onChange: (e) => onChange(id, e.target.value)
                }}
            />
        )
    }
}
